// Message thread and reply-box styling (2026-10-08), from the theme's
// palette.message tokens (theme.js). One place, so every message bubble and
// every reply box (an editable box whose text is sent to the customer) looks
// the same. The reply-box fill and the link color apply in dark mode only;
// light mode renders exactly as before.
//
// Display only: these are CSS rules on the containers, never a change to the
// HTML that is sent.

// A message bubble's background: navy-or-slate in dark, the old tints in light.
export function messageBubbleBg(theme, direction) {
  return direction === 'outbound' ? theme.palette.message.outbound : theme.palette.message.inbound
}

// Links inside a message body or the reply editor. Dark mode only: every
// state (unvisited and visited) in the one link color, underlined, with a
// visible focus ring. Emails carry their own inline link colors (e.g.
// style="color:#0563C1"), unreadable on a dark surface, so this overrides
// them with !important, scoped to the container it is applied to.
export function messageLinkSx(theme) {
  const link = theme.palette.message.link
  if (theme.palette.mode !== 'dark' || !link) return {}
  return {
    '& a, & a:link, & a:visited, & a *': { color: `${link} !important`, textDecoration: 'underline' },
    '& a:focus-visible': { outline: `2px solid ${link}`, outlineOffset: '2px' },
  }
}

// The text inside a message bubble (2026-10-15; prod contact 6951817). Dark
// mode only: an email's own inline text colors (e.g. style="color:#333333")
// are dark text on the slate or navy bubble, and its own inline backgrounds
// (white or light boxes) show as bright patches. Every descendant takes the
// theme's primary text color and a transparent background, with !important
// to beat the inline styles; the bubble's own text is primary too (light mode
// keeps text.secondary). Images and buttons keep their own styling. The
// selector's exclusions sit in :where(), so the rule stays at the lowest
// specificity and messageLinkSx()'s link colors always win over it. Never
// for the reply editor or reply boxes (the agent's own text).
export function messageTextSx(theme) {
  if (theme.palette.mode !== 'dark') return {}
  const text = theme.palette.text.primary
  return {
    color: text,
    '& *:where(:not(img, button))': { color: `${text} !important`, backgroundColor: 'transparent !important' },
  }
}

// An outlined TextField that is a reply box: the input area takes the reply
// fill in dark mode. Its border, focus color, label, placeholder and disabled
// states are MUI's own and unchanged.
export function replyBoxFieldSx(theme) {
  if (theme.palette.mode !== 'dark') return {}
  return { '& .MuiInputBase-root': { backgroundColor: theme.palette.message.replyBox } }
}

// The rich email editor's bordered surface (toolbar and content together, so
// the box reads as one navy panel, as the TextField reply boxes do).
export function replyEditorSurfaceSx(theme) {
  if (theme.palette.mode !== 'dark') return {}
  return { backgroundColor: theme.palette.message.replyBox }
}
